import type { FC } from 'react';
import type { LabelProps } from './types';
import * as Styled from '../../styled';

export const Label: FC<LabelProps> = (props) => {
  const { flag, country, language } = props;

  return (
    <Styled.Label>
      <img src={flag} alt="" />

      <div>
        <Styled.Country>{country}</Styled.Country>
        <Styled.Language>{language}</Styled.Language>
      </div>
    </Styled.Label>
  );
};
